import styled from '@emotion/styled'

const StyledContainer = styled.div`
  .input-group .left-input {
    border-bottom-right-radius: 0 !important;
    border-top-right-radius: 0 !important;
    border-right-width: 0 !important;
  }
  .input-group .right-input {
    border-bottom-left-radius: 0 !important;
    border-top-left-radius: 0 !important;
  }
`

export default StyledContainer
